module.exports = __webpack_public_path__ + "img/logo.a574f4f6.png";